/* imported only from app.js
DO NOT USE ANYWHERE ELSE
 */

import {getXSRFToken} from "../utils/util"
import {getGlobalStore} from "../state/globalStore"
import * as types from "../state/actionTypes"
import {logError, logout} from "../state/app/actions"

let inactivityTimeout
import(/* webpackChunkName: "axios" */ "axios").then(module => {
  const axios = module.default
  const urlIgnore = ['/api/logger/log-js-user-event', '/api/art/artEvent', '/logout']

  axios.defaults.headers.put['Content-Type'] = 'application/json'
  axios.defaults.headers.put['X-Requested-With'] = 'XMLHttpRequest'
  axios.defaults.headers.put['X-XSRF-TOKEN'] = getXSRFToken()

  axios.defaults.headers.post['Content-Type'] = 'application/json'
  axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
  axios.defaults.headers.post['X-XSRF-TOKEN'] = getXSRFToken()

  axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    const store = getGlobalStore()
    const response = error.response
    if ([401].includes(response.status)) {
      if (!urlIgnore.includes(response.config.url)) {
        window.location.assign("/login?redirectUrl=" + window.location.href)
      }
      return
    }

    if (response && [403, 453].includes(response.status)) {
      alert("Your session has expired.  Please login again.")
      store.disptach(logout())
      return
    }
    store.dispatch({type: types.LOADING_STOPPED})
    store.dispatch(logError(error))
  })

  axios.interceptors.request.use(function (config) {
    if (inactivityTimeout) {
      clearTimeout(inactivityTimeout)
      inactivityTimeout = null
    }
    inactivityTimeout = setTimeout(() => {
      getGlobalStore().dispatch(logout())
    }, 1000 * 60 * 30)
    return config
  }, function (error) {

    return Promise.reject(error)
  })

  import(/* webpackChunkName: "axios" */ "axios-retry").then(module => {
    // Override retryCondition to include POST
    module.default(axios, {
      retries: 4,
      retryDelay: (retryCount) => {
        return retryCount * 500
      },
      retryCondition: (error) => {
        if (!error.config) {
          return false
        }
        return module.isRetryableError(error)
      }
    })
  })
})
